var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnreadDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 7,
    viewBox: "0 0 6 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 34"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 68",
    cx: 3,
    cy: 3.61328,
    r: 3,
    fill: "#BA0060"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadDot);
export default __webpack_public_path__ + "static/media/unread-dot.4abb7e0dc80d5fa9080f9b0067fb2d06.svg";
export { ForwardRef as ReactComponent };